import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../auth.service';
import { QuibblService } from '../../../quibbl.service';
import { ActivatedRoute } from '@angular/router';
import { contentTransition } from "../../../animations";

@Component({
  selector: 'app-quibbl-votes',
  templateUrl: './quibbl-votes.component.html',
  styleUrls: ['./quibbl-votes.component.scss'],
  animations: [contentTransition()],
  host: {'[@routerTransition]': ''}
})
export class QuibblVotesComponent implements OnInit {

  public currentVoteList;
  public voteListSubscription;
  public quibblIdentifier: string;
  public parentRouteSubscription;
  public currentQuibbl;
  public myCurrentVote = -1;
  public currentVoteSubscription
  public rightPayout;
  public wrongPayout;
  public now = Date.now();

  constructor(public route: ActivatedRoute,
              private auth: AuthService,
              private _qb: QuibblService) { }

  ngOnInit() {
    this.parentRouteSubscription = this.route.parent.params.subscribe(params => {
      this.quibblIdentifier = params['quibblId'];
      this.currentQuibbl = this._qb.getQuibbl(this.quibblIdentifier);

      if(this.voteListSubscription) this.voteListSubscription.unsubscribe();
      this.voteListSubscription = this._qb.getQuibblVoteList(this.quibblIdentifier)
        .subscribe(votes => {
          this.currentVoteList = [];
          for(let i=votes.length-1; i>=0; i--) {
            this.currentVoteList.push(votes[i]);
            let user = votes[i].$key;
            this._qb.getCommentsForQuibblAndUser(this.quibblIdentifier, user).subscribe(comments => {
              if(comments && comments.length > 0) {
                votes[i].message = comments[0].message;
              }
            });
          }
        });

      this.auth.isLoggedIn.subscribe((value: boolean) => {
        this.myCurrentVote = -1;

        if(value) {
          if(this.currentVoteSubscription) this.currentVoteSubscription.unsubscribe();
          this.currentVoteSubscription = this._qb.getCurrentVoteForUser(this.quibblIdentifier, this.auth.userIdentifier).subscribe(vote => {
            //console.log(vote);
            if(vote) {
              this.rightPayout = vote.rightPayout;
              this.wrongPayout = vote.wrongPayout;
              this.myCurrentVote = vote.vote;
            }
          });
        }
      });
    });
  }

  ngOnDestroy() {
    if(this.voteListSubscription) this.voteListSubscription.unsubscribe();
    if(this.parentRouteSubscription) this.parentRouteSubscription.unsubscribe();
    if(this.currentVoteSubscription) this.currentVoteSubscription.unsubscribe();
  }


}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-votes/quibbl-votes.component.ts